<template>
  <div>
  <Base-header class="pb-6 pb-7 bg-gradient-success"></Base-header>
    <div id="summaryContainer" class="bg-white"></div>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";
import * as SurveyAnalytics from "survey-analytics";
import { json, data } from "@/models/analytics_data";
import BaseHeader from "@/components/admin/BaseHeader";

import "survey-analytics/survey.analytics.css";

/* eslint-disable vue/no-unused-components */
export default {
  components: {
    SurveyVue,
    BaseHeader
  },

  data() {
    const survey = new SurveyVue.Model(json);
    return { survey, data };
  },

  mounted() {
    var surveyAnalyticsDataTables = new SurveyAnalytics.VisualizationPanel(
      this.survey.getAllQuestions(),
      this.data
    );
    surveyAnalyticsDataTables.render(
      document.getElementById("summaryContainer")
    );
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.sa-panel__header{
  display: none!important;
}
</style>
